import { IconFont } from '@/components/IconFont'
import { changePassword } from '@/services/user/user.service'
import { APP_NAME } from '@/utils/constants'
import { useRequest, useTitle } from 'ahooks'
import { Button, Form, Input } from 'antd'
import React, { memo } from 'react'
import { useNavigate } from 'react-router'

export default memo(function ChangePassword() {
  useTitle(`${APP_NAME}-Change password`)
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const { loading, run } = useRequest(changePassword, {
    manual: true,
    onSuccess: () => {
      navigate('/login')
    }
  })

  return (
    <>
      <div className='mb-2'>Your password has expired. Please reset your password to log in.</div>
      <Form
        form={form}
        autoComplete='off'
        layout='vertical'
        onFinish={(values) => {
          run(values)
        }}
      >
        <Form.Item
          label='Old Password'
          name='oldPassword'
          rules={[
            { required: true, message: 'Please enter password' },
            { min: 6, message: 'Minimum length of password is 6 digits.' },
            { max: 20, message: 'Maximum length of password is 20 digits.' }
          ]}
        >
          <Input
            size='large'
            autoComplete='new-password'
            prefix={<IconFont type={'icon-lock'} />}
            type='password'
            placeholder='Enter password'
          />
        </Form.Item>

        <Form.Item
          label='New Password'
          name='newPassword'
          rules={[
            { required: true, message: 'Please enter password' },
            { min: 6, message: 'Minimum length of password is 6 digits.' },
            { max: 20, message: 'Maximum length of password is 20 digits.' }
          ]}
        >
          <Input
            size='large'
            autoComplete='new-password'
            prefix={<IconFont type={'icon-lock'} />}
            type='password'
            placeholder='Enter password'
          />
        </Form.Item>

        <Form.Item>
          <Button
            htmlType='submit'
            type='primary'
            size='large'
            loading={loading}
            style={{ width: '100%', marginBottom: '5px' }}
          >
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </>
  )
})
